import React  from 'react';
import {FieldViewProps} from "../../../../render/view";

export default function FieldDateRange_View(props:FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    const classes = Classes("ui5-txt-default no-wrap", props.className)

    return (
        <div className={classes}>
            {props.field.getDisplayValue(value)}
        </div>
    );
}
